import firebase from 'firebase';

export const firebaseConfig = {
    apiKey: "AIzaSyA_-voK6vR7kDCNCmtXDfvkQ77bqUE8hls",
    authDomain: "social-media-app-d7f01.firebaseapp.com",
    projectId: "social-media-app-d7f01",
    storageBucket: "social-media-app-d7f01.appspot.com",
    messagingSenderId: "788434366774",
    appId: "1:788434366774:web:ba89e79d4bf3f71c1b4397",
    measurementId: "G-0VLVK3PNXH"
};

firebase.initializeApp(firebaseConfig);
const storage = firebase.storage();
export default storage;